import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UploadJob {
  id: string;
  title: string;
  type: string;
  status: 'uploading' | 'processing' | 'completed' | 'error';
  progress: number;
  thumbnailUrl?: string; // optional base64 or blob URL
  error?: string;
}

interface UploadState {
  jobs: UploadJob[];
  isMinimized: boolean;
}

const initialState: UploadState = {
  jobs: [],
  isMinimized: false,
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    addUploadJob(state, action: PayloadAction<UploadJob>) {
      // Add to the front of the list
      state.jobs.unshift(action.payload);
      state.isMinimized = false; // Pop open if new item is added
    },
    updateUploadJob(state, action: PayloadAction<{ id: string } & Partial<UploadJob>>) {
      const index = state.jobs.findIndex((job) => job.id === action.payload.id);
      if (index !== -1) {
        state.jobs[index] = { ...state.jobs[index], ...action.payload };
      }
    },
    removeUploadJob(state, action: PayloadAction<string>) {
      state.jobs = state.jobs.filter((job) => job.id !== action.payload);
    },
    clearCompletedJobs(state) {
      state.jobs = state.jobs.filter((job) => job.status !== 'completed');
    },
    toggleMinimize(state) {
      state.isMinimized = !state.isMinimized;
    },
  },
});

export const {
  addUploadJob,
  updateUploadJob,
  removeUploadJob,
  clearCompletedJobs,
  toggleMinimize,
} = uploadSlice.actions;

export default uploadSlice.reducer;
